// extracted by mini-css-extract-plugin
export var featureOverview = "styles-module--featureOverview--01201";
export var features = "styles-module--features--80aeb";
export var featuresDescription = "styles-module--featuresDescription--08055";
export var featuresIcon = "styles-module--featuresIcon--1604d";
export var featuresItem = "styles-module--featuresItem--78828";
export var featuresTitle = "styles-module--featuresTitle--f5389";
export var title = "styles-module--title--98bb3";